<template>
  <section>
    <div>
      <!-- <nav-login />
      <nav-contact /> -->
      <span>
        Mobilize
        <span class="bold">SHARE </span>
      </span>
    </div>
  </section>
</template>

<script>
// import NavLogin from './NavLogin';
// import NavContact from './NavContact';

export default {
  name: 'NavTop',
  components: {
    // NavLogin,
    // NavContact,
  },
};
</script>

<style scoped lang="scss">
@import "../../../../../_src/sass/config/vars";
@import "../../../../../_src/sass/config/mixins";
@import "../../../../../_src/sass/config/responsive";

section {
  border-bottom: 1px solid #eee;
  //background-color: $silver;
  display: flex;
  justify-content: center;
  padding: 20px 0;

  @include teq-breakpoint($medium) {
    flex: 1;
  }
}

section div {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 15px;

  span {
    @include font-size(16px);

    color: black;
    font-family: $f-graphie-book;

    .bold {
      font-family: $f-graphie-bold;
      font-weight: 700;
    }
  }

  svg {
    height: 10px;
    position: absolute;
    right: 20px;
    top: 25px;
    transform: rotate(90deg);
    width: 10px;
  }

  @include teq-breakpoint($medium) {
    @include shared-wrapper;

    flex-direction: row;
    padding: 0;
  }
}
</style>
